//# sourceMappingURL=qr.interface.js.map


//////////////////
// WEBPACK FOOTER
// ./~/pdfmake-wrapper/lib/interfaces/qr.interface.js
// module id = 1181
// module chunks = 4